<template>
    <div class="header-title x-flex-align">
        <span class="back iconfont x-grey-text ux_icon_arrow_left" v-if="showBack" @click="back"></span>
        <span class="x-weight-content">{{title}}</span>
        <span class="edit iconfont ux_icon_edit" v-if="showEdit" @click="edit"></span>
        <span class="delete iconfont ux_icon_delete" v-if="showDelete" @click="deleteData"></span>
        <slot></slot>
    </div>
</template>

<script>
export default {
  name: 'MyHeadTitle',
  props: {
    title: {
      type: String,
      default: ''
    },
    showEdit: {
      type: [Boolean],
      default: false
    },
    showBack: {
      type: Boolean,
      default: false
    },
    showDelete: {
      type: Boolean,
      default: false
    }
  },
  methods: {

    back() {
      this.$router.go(-1);
    },

    /**
         * 编辑
         */
    edit() {
      this.$emit('edit');
    },

    /**
         * 删除
         */
    deleteData() {
      this.$emit('deleteData');
    }
  }
};
</script>

<style lang="scss" scoped>
    .header-title {
        height: 50px;
        padding: 0 20px;
        border-bottom: 1px solid #E8ECF2;

        .iconfont {
            font-size: 16px;
        }

        .back {
            margin: 0 10px 0 -5px;
            cursor: pointer;
        }

        .edit {
            margin-left: 10px;
            color: #0087ff;
            font-weight: normal;
            cursor: pointer;
            user-select: none;
        }

        .delete {
            margin-left: auto;
            color: #0087ff;
            font-weight: normal;
            cursor: pointer;
        }

        .el-button {
            margin-left: auto;
        }
    }
</style>
